import { Component } from '@angular/core';

@Component({
  selector: 'app-values',
  standalone: true,
  imports: [],
  templateUrl: './values.component.html',
  styleUrl: './values.component.scss'
})
export class ValuesComponent {

}
